<template>
    <div class="navbarContainer">
      <!-- logo -->
      <a href="/home"><img class="logo" :src="logo" alt="Logo" /></a>
      
      <nav>
        <ul>
          <li><a href="#services">Nos services</a></li>
          <li><a href="#solution">A propos de prexange</a></li>
        </ul>
      </nav>
       
      <!-- action button -->
      <div class="actionButtonsContainer">
        
        <div class="actionButtons">
          <Icon icon="bx:bx-user" height="24" />
          <router-link to="/login" class="text"><span> Se connecter</span></router-link>
        </div>
        <div class="signInBtn">
          <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
         <a type='button' href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="color: white; text-decoration: none;"><span>Demande d’inscription </span></a> 
          
        </div>
        <!-- hamburger button -->
        <div class="humbergerBtn" @click="toggleSidebar">
          <Icon icon="bx:bx-menu" height="30" />
        </div>
      </div>
      <!-- Sidebar -->
      <div v-if="isSidebarOpen" class="sidebar">
        <div class="closeBtn" @click="toggleSidebar">
          <Icon icon="bx:bx-x" height="30" />
        </div>
        <ul>
          <li><a href="#services">Nos services</a></li>
          <li><a href="#solution">A propos de prexange</a></li>
        </ul>
      </div>
      <div v-if="isSidebarOpen" class="sidebarOverlay" @click="toggleSidebar"></div>
    </div>
  </template>
  

<script>
import logo from '@/assets/images/LogoPrexange.png';
import { Icon } from '@iconify/vue2';

export default {
  name: 'Navbar',
  components: {
    Icon,
  },
  data() {
    return {
      logo: logo,
      isSidebarOpen: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
  },
};
</script>

<style lang="scss">
@import './navbar.scss'
</style>